import {Mapper} from '@s-ui/domain'

import AdsMappersFactory from '../../ads/Mappers/factory.js'

export class AssistantBlockFiltersMapper extends Mapper {
  #config
  #listingSectionIDsByCategories
  #httpSearchUrlResponseToSearchDataAdsValueObjectMapper

  constructor({config, listingSectionIDsByCategories, httpSearchUrlResponseToSearchDataAdsValueObjectMapper}) {
    super()
    this.#config = config
    this.#listingSectionIDsByCategories = listingSectionIDsByCategories
    this.#httpSearchUrlResponseToSearchDataAdsValueObjectMapper = httpSearchUrlResponseToSearchDataAdsValueObjectMapper
  }

  static create = ({config}) => {
    return new AssistantBlockFiltersMapper({
      config,
      listingSectionIDsByCategories: config.get('listingSections').LISTING_SECTION_IDS_BY_CATEGORIES,
      httpSearchUrlResponseToSearchDataAdsValueObjectMapper:
        AdsMappersFactory.httpSearchUrlResponseToSearchDataAdsValueObjectMapper({config})
    })
  }

  /**
   *
   * @param {Object} block chat assistant block with content, type and filters
   * @returns block with mapped filters to use on search
   */
  map = block => {
    // Only transform blocks with filters (search_results type)
    if (!block?.filters) {
      return block
    }

    // Build the structure expected by HttpSearchUrlResponseToSearchDataAdsValueObjectMapper
    const searchData = {
      search: {
        filters: block.filters,
        sort: block.sort || {term: this.#config.get('SORT_FIELDS').RELEVANCE, order: this.#config.get('ORDER').ASC},
        pagination: block.pagination || {page: this.#config.get('DEFAULT_PAGE_NUMBER')}
      }
    }

    // Use the mapper to transform filters
    const mappedSearchData = this.#httpSearchUrlResponseToSearchDataAdsValueObjectMapper.map(searchData)
    const mappedFilters = mappedSearchData.toJSON()
    const filters = mappedFilters?.search || {}

    // Get list section id by filters category id
    const listingSectionId = this.#listingSectionIDsByCategories[filters.categoryId]

    return {
      ...block,
      filters,
      listingSectionId
    }
  }
}
